import BreadCrumbs from "../Breadcrumbs"
import SaveInterventionsButton from "./SaveInterventionsButton"

const InterventionsEditorLayout = ({breadcrumbs=[], children}) => {

    return (
        <>
        <BreadCrumbs crumbs={breadcrumbs} />
        <SaveInterventionsButton />
            {children}
        <SaveInterventionsButton />
        </>
    )
}

export default InterventionsEditorLayout